import { Paper, Stack, Typography, Box } from '@mui/material';
import { CheckCircle, ErrorOutline } from '@mui/icons-material';

function Kpi({ label, value, icon, color, onClick, active, activeColor }) {
  return (
    <Paper onClick={onClick}
           sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', gap: 1.2, minWidth: 130,
                 cursor: onClick ? 'pointer' : 'default',
                 outline: active ? `2.5px solid ${activeColor || color}` : '2.5px solid transparent',
                 transition: 'outline-color 120ms, box-shadow 120ms',
                 '&:hover': onClick ? { boxShadow: '0 3px 10px rgba(15,23,42,.14)' } : {} }}>
      <Box>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>{label}</Typography>
        <Typography variant="h6" sx={{ lineHeight: 1, color }}>{value}</Typography>
      </Box>
      {icon}
    </Paper>
  );
}

export default function KpiBar({ items, filtered, filters, setFilters }) {
  const rev = items.filter(i => i.meta.stato === 'revisionato').length;
  const dar = items.length - rev;
  const toggleStato = (v) => setFilters(f => ({ ...f, stato: f.stato === v ? null : v }));

  return (
    <Stack direction="row" spacing={1.5} sx={{ p: 1.5, pb: 0.5, flexWrap: 'wrap', alignItems: 'center' }}>
      <Kpi label="Revisionati" value={rev} color="#16a34a" icon={<CheckCircle sx={{ color: '#16a34a' }} />}
           onClick={() => toggleStato('revisionato')} active={filters.stato === 'revisionato'} />
      <Kpi label="Da rivedere" value={dar} color="#ea580c" icon={<ErrorOutline sx={{ color: '#ea580c' }} />}
           onClick={() => toggleStato('da rivedere')} active={filters.stato === 'da rivedere'} />
      <Kpi label="Totale cartelloni" value={items.length} color="#0f172a"
           onClick={() => setFilters(f => ({ ...f, stato: null }))} active={false} />
      {filtered != null && filtered !== items.length && (
        <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
          {filtered} risultati coi filtri attivi
        </Typography>
      )}
    </Stack>
  );
}
